<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form (submit)="search()" #form="ngForm" class="form-validate">
      <div class="row g-3 mb-3">
        <label for="personalId" class="col-form-label col-md-4 col-xl-auto">เลขประจำตัวประชาชน</label>
        <div class="col-md-6 col-xl-auto">
          <input type="text"
                 class="form-control"
                 id="personalId-search"
                 [(ngModel)]="personalId"
                 name="personalId"
                 required
                 #personalIdInput="ngModel">
          @if (personalIdInput.invalid && (personalIdInput.dirty || personalIdInput.touched)) {
            <custom-error *ngIf="personalIdInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>

        <div class="offset-md-4 offset-xl-0 col-xl-auto">
          <button type="submit" class="btn btn-primary">
            <i class="bi bi-search me-1"></i>ค้นหา
          </button>
          <button (click)="resetSearchParams()" type="button" class="btn btn-default mx-2">
            ล้างค่า
          </button>
        </div>
      </div>
      <gt-error code="Mod11"></gt-error>
    </form>
  </div>
</div>

@if (data()) {
  <div class="card custom-box mb-3 border-0">
    <div class="card-body">
      <div class="row justify-content-between">
        <h6 class="col-auto col-form-label fw-normal text-muted">
          ข้อมูล ณ วันที่ {{ data()?.checkDate | thaidatetime :{month: 'long'} }}
        </h6>
      </div>
      <div class="card-body border rounded">
        <div class="row">
          <div class="col-xl-10">
            <div class="row mb-3">
              <label for="personalId" class="col-xl-2 col-form-label">เลขประจำตัวประชาชน</label>
              <div class="col-xl-4">
                <input type="text" class="form-control" id="personalId" formDisabled
                       [ngModel]="data()?.personalData?.personalId">
              </div>
              <label for="fullName" class="col-xl-2 col-form-label">ชื่อ-สกุล</label>
              <div class="col-xl-4">
                <input type="text" class="form-control" id="fullName" formDisabled
                       [ngModel]="data()?.personalData?.firstName + ' ' + data()?.personalData?.lastName">
              </div>
            </div>
            <div class="row mb-3">
              <label for="startDate" class="col-xl-2 col-form-label">วันที่สำนักงานประกันสังคมส่งข้อมูล</label>
              <div class="col-xl-4">
                <input type="text" class="form-control" id="startDate"
                       formDisabled
                       [ngModel]="tempSSS?.processDate | thaidatetime :{month: 'long'}">
              </div>
              <label for="expireDate" class="col-xl-2 col-form-label">วันสุดท้ายที่สามารถใช้สิทธิประกันสังคม</label>
              <div class="col-xl-4">
                <input type="text" class="form-control" id="expireDate"
                       formDisabled
                       [ngModel]="tempSSS?.displayExpDate | thaidatetime :{month: 'long', showTime: false}">
              </div>
            </div>
          </div>
        </div>
        <div class="row ms-5">
          <b>
            หมายเหตุ
          </b>
        </div>
        <div class="row ms-5">
          1. สำนักงานประกันสังคมส่งข้อมูลหมดสิทธิประกันสังคมให้สปสช.เป็นรายวันในวันถัดไป เวลา 06.00 น.
          สปสช.ดำเนินการปลดสิทธิเวลา 10.00-10.30 น.
        </div>
        <div class="row ms-5">
          2. กรณีหมดสิทธิประกันสังคมแล้วยังมีสิทธิข้าราชการเบิกจากกรมบัญชีกลางจะได้รับการปลดสิทธิตามรอบกรมบัญชีกลาง
        </div>
        <div class="row ms-5">
          3. วันสุดท้ายที่สามารถใช้สิทธิประกันสังคม= Expdate ที่ประกันสังคมส่งข้อมูล
        </div>
      </div>
    </div>
  </div>
}
